import type { SourceGraph } from './graph'
import { edgeKey } from './layout'

// What lights up when you point at a box: its whole route through the map.
export type Trace = { nodes: ReadonlySet<string>; edges: ReadonlySet<string> } // edges via edgeKey

// Walk one direction from `start` (itself included).
function reach(graph: SourceGraph, start: string, forward: boolean): Set<string> {
  const seen = new Set([start])
  const queue = [start]
  for (let id = queue.pop(); id !== undefined; id = queue.pop()) {
    for (const edge of graph.edges) {
      const [here, next] = forward ? [edge.from, edge.to] : [edge.to, edge.from]
      if (here === id && !seen.has(next)) {
        seen.add(next)
        queue.push(next)
      }
    }
  }
  return seen
}

// Forward and backward are kept apart on purpose: pointing at a section should
// light the jobs and sources behind it, not those jobs' other sections, which
// is what the union of both walks' edges would do.
export function traceFrom(graph: SourceGraph, id: string): Trace {
  const ahead = reach(graph, id, true)
  const behind = reach(graph, id, false)
  const edges = graph.edges
    .filter(
      (edge) =>
        (ahead.has(edge.from) && ahead.has(edge.to)) ||
        (behind.has(edge.from) && behind.has(edge.to)),
    )
    .map(edgeKey)
  return { nodes: new Set([...ahead, ...behind]), edges: new Set(edges) }
}
